import Heading from 'LuxKit/Typography/Heading'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import { rem } from 'polished'
import styled from 'styled-components'
import OfferTypesCarousel from './OfferTypesCarousel'
import Group from 'components/utils/Group'
import { isWhitelabelBrand } from 'lib/whitelabels/whitelabels'
import config from 'constants/config'

const Root = styled.div`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function BrowseOfferTypes() {
  const intl = useIntl()
  const isWhitelabel = isWhitelabelBrand(config.BRAND)

  const headingText = useMemo(
    () => {
      if (isWhitelabel) {
        return intl.formatMessage(
          {
            id: 'ENTwpUoGZH',
            defaultMessage: 'Explore all offers to find your next <i>getaway</i>',
            description: 'Browse offer types heading for whitelabel brands',
          },
          {
            i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
          },
        )
      }
      return intl.formatMessage(
        {
          id: 'rkwjaC7O3A',
          defaultMessage: 'Browse all offers to find your next <i>escape</i>',
          description: 'Browse offer types heading for default brands',
        },
        {
          i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
        },
      )
    },
    [intl, isWhitelabel],
  )

  return (
    <Root data-testid="browse-offer-types">
      <Group direction="vertical" gap={20}>
        <LayoutContainer>
          <Heading variant="heading2">{headingText}</Heading>
        </LayoutContainer>
        <OfferTypesCarousel />
      </Group>
    </Root>
  )
}

export default React.memo(BrowseOfferTypes)
